module.exports = __webpack_public_path__ + "static/media/pic_fenxiang.3392f6cd.png";